import '~/assets/scss/legal-persons.scss'

import getSwiperSlider from '~/js/modules/slider'


window.addEventListener(`DOMContentLoaded`, () => {
  document.querySelectorAll('.js-scroll-button').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('data-href')).scrollIntoView({ block: "center", behavior: "smooth" });
    });
  });

  const smiSlider = document.querySelector(`.js-smi-slider`)
  if (smiSlider) {
    const smiSwiperParams = {
      speed: 1000,
      slidesPerView: 1.3,
      loop: false,
      allowTouchMove: true,
      watchSlidesProgress: true,
      touchStartForcePreventDefault: true,
      centeredSlides: false,
      slidesOffsetBefore: 20,
      spaceBetween: 16,
      navigation: {
        enabled: false
      },
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
        forceToAxis: true
      }
    }
    const swiper = getSwiperSlider(smiSlider, smiSwiperParams)
  }
  
  const legalForm = document.querySelector(`.js-form-legal-persons`);
  if(legalForm) {
    legalForm.addEventListener('submit', function () {
      const y = document.querySelector(`#form-contact`).getBoundingClientRect().top + window.pageYOffset - 128;
      window.scrollTo({ top: y, behavior: 'smooth' });
    })
  }
})